import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot } from "@angular/router";
import { GetMatchDetailUseCase } from "@app/core/match/domain/get-match-detail.use-case";
import { MissingCredentialsError } from "@app/core/shared/domain/missing-credentials.error";
import { TokenRepo } from "@app/core/shared/domain/token.repo";
import { Observable, map, throwError, of, switchMap, take } from "rxjs";
import { MatchRepo } from "./match.repo";

/**
 * Use case to check if the user is alread selected
 */
@Injectable({
  providedIn: "root",
})
export class IsPlayerAlredySelected {
  constructor(
    private matchRepo: MatchRepo,
    private tokenRepo: TokenRepo
  ) {}

  public execute(route: ActivatedRouteSnapshot): Observable<boolean> {
    //return of(true)
    const token = this.tokenRepo.get();
    if (token == null) {
      return throwError(() => new MissingCredentialsError());
    }
    return this.getIsPlayerAlreadySelected(
      route.params["matchId"],
      token ?? ""
    );
  }

  //TODO: This should be replace by a funcion that checks if the user already selected a player for this match
  getIsPlayerAlreadySelected(
    matchId: string,
    token: string
  ): Observable<boolean> {
    return this.matchRepo.isPlayerAlreadySelectedInMatch(matchId, token).pipe(
      map((isPlayerAlreadySelected) => {
        return isPlayerAlreadySelected;
      })
    );
  }
}
